









import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class SearchButton extends Vue {
  @Prop({ default: false })
  isDisabled!: boolean

  @Prop({ default: false })
  isShowIcon!: boolean

  @Prop({ default: false })
  isHideLabel!: boolean

  @Prop()
  onClick!: () => void
}
